import { render, staticRenderFns } from "./FactureInfos.vue?vue&type=template&id=b60401ce&scoped=true&"
import script from "./FactureInfos.vue?vue&type=script&lang=js&"
export * from "./FactureInfos.vue?vue&type=script&lang=js&"
import style0 from "./FactureInfos.vue?vue&type=style&index=0&id=b60401ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60401ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60401ce')) {
      api.createRecord('b60401ce', component.options)
    } else {
      api.reload('b60401ce', component.options)
    }
    module.hot.accept("./FactureInfos.vue?vue&type=template&id=b60401ce&scoped=true&", function () {
      api.rerender('b60401ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FactureInfos.vue"
export default component.exports